/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useMemo, useState } from 'react'
import CN from 'classnames'

import columnsStructure from './columnsStructure'
import Table from './Table'

import './DataTable.scss'

export const DataTable = ({
  shippingQtyUpdateAccess,
  itemData,
  className,
  setDeleteObjectDetails,
  deleteObjectDetails,
  shipmentId,
  shipmentStatus,
  warehouseIntegrationName,
  useUpdateShippingQty,
  ...restProps
}) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const columns = useMemo(() => columnsStructure, [])
  const [editedColumns, setEditedColumns] = useState(columns || [])
  useEffect(() => {
    if (itemData?.length > 0) {
      setData([...itemData])
    }
    if (shipmentStatus === 'CLOSED') {
      const newColumns = columns.filter(
        (column) => column.accessor !== 'actions',
      )
      setEditedColumns(newColumns)
    } else {
      setEditedColumns(columns)
    }
  }, [itemData])

  return (
    <div className={CN('data-table w-full text-sm', className)} {...restProps}>
      <Table
        shippingQtyUpdateAccess={shippingQtyUpdateAccess}
        data={data}
        loading={loading}
        columns={editedColumns}
        setDeleteObjectDetails={setDeleteObjectDetails}
        deleteObjectDetails={deleteObjectDetails}
        shipmentId={shipmentId}
        shipmentStatus={shipmentStatus}
        warehouseIntegrationName={warehouseIntegrationName}
        setData={setData}
        updateShippingQty={useUpdateShippingQty}
      />
    </div>
  )
}

export default DataTable
